// extracted by mini-css-extract-plugin
export default {"expression":"styles__expression___BSBoU","input":"styles__input___cEQhR","select":"styles__select___P2aPz styles__input___cEQhR"};